module.exports = __webpack_public_path__ + "images/errors/team-full-9eb4e489606ba0eb0d51e857b158de4a.png";